var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{staticClass:"timesheet-skeleton-list",attrs:{"loading":"","type":"week-timesheet-group","types":{
    'week-timesheet-group': 'week-heading, timesheet-card',
    'week-heading': 'heading',
    'timesheet-card': 'avatar-text, timesheet-table',
    'avatar-text': 'avatar, text',
    'timesheet-table': 'table-thead, divider, table-row, divider, table-row',
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }